import React from 'react';
import { Button } from 'react-bootstrap';
import { goToDashboard } from '../nav/navigationService';

class NoMatch extends React.Component {
    render() {
        return (
            <div>
                <span className="black-font">
                    Die Seite wurde leider nicht gefunden.
                </span>
                <br />
                <Button onClick={goToDashboard}>Zur Startseite</Button>
            </div>
        );
    }
}

export default NoMatch;
